import React, { useEffect, useState } from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import { useHistory } from "react-router-dom";

import GenericTemplate from "../../templates/GenericTemplate";
import { ApolloBreadcrumbs } from "../../atom/Apollo_Breadcrumbs";
import { CustomizedSnackbars } from "../../atom/Apollo_Mesasge";
import { ApolloRightDrawerContext, RightDrawer } from "../../molecule/Apollo_RightDrawer";
import { ApolloContext } from "../../atom/Apollo_Context";
import { ApolloAxios } from "../../atom/Apollo_ApiRequest3";
import { ApolloMessage } from "../../atom/Apollo_Mesasge";
import { apollo_useStyles } from "../../atom/Apollo_styles";
import { apollo_past_report_path } from "../../atom/Apollo_links";
// メッセージ定義
import { GetMessage, UI_REPORT_LIST } from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import { ApolloExpired } from "../../atom/Apollo_Expired";

import { ApolloDataTable, STORAGE_KEY } from "../../atom/Apollo_DataTable";
import { MUISortOptions, SelectableRows } from "mui-datatables";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import { Backdrop } from "@material-ui/core";
import { Bars } from "react-loader-spinner";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

import ApolloPastReportDownload from "../../molecule/PASTREPORT/Apollo_PastReportDownload";
import {PastReportApiRow, PastReportRow} from "./PastReportModel";
import {APOLLO_PAGE_ID} from "../../common/Apollo_LocalStorageSettings";

const NULL_YEAR = "0001";

const pfLabel = (v: number) => {
  switch (Number(v)) {
    case 1: return "パフォーマンス";
    case 2: return "メール";
    case 3: return "ディスプレイ";
    default: return String(v ?? "");
  }
};

const PastReportPage: React.FC = () => {
  const classes = apollo_useStyles();
  const { data, setmsg } = React.useContext(ApolloMessage);
  const { state } = React.useContext(ApolloContext);
  const { drawerState, setDrawerState } = React.useContext(ApolloRightDrawerContext);

  const [rows, setRows] = useState<PastReportRow[]>([]);
  const [progress, setProgress] = useState<boolean>(true);

  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();
  const accountId = state?.current?.accountId;

  // 並び順
  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "extractionEndDate",
    direction: "desc",
  });
  const [numberOfRows, setNumberOfRows] = useState(10);
  const selectableRows: SelectableRows = "none";

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: { ...data, loading: true },
    });

    const url = `${apollo_past_report_path}/${accountId}`;
    ApolloAxios.get(url)
      .then((response) => {
        if (response.data.resultCode === 0) {
          const list: PastReportApiRow[] = response?.data?.result ?? [];
          setRows(normalize(list));
        } else {
          console.log(response.data.message);
          setmsg({
            type: "all",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0", UI_REPORT_LIST, "E", "0"),
              loading: false,
            },
          });
        }
      })
      .catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0", UI_REPORT_LIST, "E", "0"), data, setmsg, history, setDrawerState, drawerState)) {
          // 認証期間切れ以外の追加処理があればここに
        }
      })
      .finally(() => {
        setmsg({
          type: "loading",
          payload: { ...data, loading: false },
        });
        setProgress(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  const normalize = (list: PastReportApiRow[]): PastReportRow[] => {
    return (list || []).map((r) => {
      const start = moment(r.extractionStartDate);
      const end = moment(r.extractionEndDate);
      const startOk = start.isValid() && start.format("YYYY") !== NULL_YEAR;
      const endOk   = end.isValid() && end.format("YYYY") !== NULL_YEAR;

      const period =
        startOk && endOk
          ? `${start.format("YYYY/MM/DD")} - ${end.format("YYYY/MM/DD")}`
          : "-";

      return {
        pastReportSettingId: r.pastReportSettingId,
        reportId: r.reportId,
        reportFileName: r.reportFileName,
        pfKbn: r.pfKbn,
        extractionStartDate: startOk ? start.toISOString() : "",
        extractionEndDate: endOk ? end.toISOString() : "",
        reportFileUrl: r.reportFileUrl,
        period,
        s3DeployReportFileName: r.s3DeployReportFileName,
      };
    });
  };

  // カラム定義（ご指定の7項目）
  const columns = [
    {
      name: "reportId",
      label: "レポートID",
      options: { filter: false, sort: true },
    },
    {
      name: "reportFileName",
      label: "レポート名",
      options: { filter: false, sort: true },
    },
    {
      name: "pfKbn",
      label: "メニュー",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => pfLabel(value),
      },
    },
    {
      name: "period",
      label: "抽出期間",
      options: { filter: true, sort: true },
    },
    {
      name: "download",
      label: "ダウンロード",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => (
          <ApolloPastReportDownload report={rows[idx]} />
        ),
      },
    },
  ];

  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.REPORT) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.REPORT,
    apolloPageId: APOLLO_PAGE_ID.PAST_REPORT_LIST,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({ name: changedColumn, direction } as MUISortOptions);
    },
    onChangeRowsPerPage: (n: number) => setNumberOfRows(n),
  };

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>

      <ApolloBreadcrumbs bread_no={80} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""} platform={""} />

      <Grid container spacing={0}>
        <Typography variant="caption">
          {"　　2022年1月から2025年9月までのレポートを広告粒度・時間単位で作成しています"}
        </Typography>
      </Grid>

      <Card className={classes.root} square variant="outlined">
        <ApolloDataTable
          title=""
          data={rows || []}
          columns={columns}
          options={{
            ...options,
            textLabels: { body: { noMatch: "該当データが存在しません" } },
          }}
        />
      </Card>
      <CustomizedSnackbars />
    </GenericTemplate>
  );
};

export default PastReportPage;
